import { createContext, useContext, useState, ReactNode } from "react";
import { LucideIcon } from "lucide-react";

interface PageMetadata {
  icon?: LucideIcon;
  title?: string;
  subtitle?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
}

interface PageMetadataContextType {
  metadata: PageMetadata;
  setMetadata: (metadata: PageMetadata) => void;
}

const PageMetadataContext = createContext<PageMetadataContextType | null>(null);

export function PageMetadataProvider({ children }: { children: ReactNode }) {
  const [metadata, setMetadata] = useState<PageMetadata>({});

  return (
    <PageMetadataContext.Provider value={{ metadata, setMetadata }}>
      {children}
    </PageMetadataContext.Provider>
  );
}

export function usePageMetadata() {
  const context = useContext(PageMetadataContext);
  if (!context) {
    throw new Error(
      "usePageMetadata must be used within a PageMetadataProvider"
    );
  }
  return context;
}
